module.exports = __webpack_public_path__ + "static/media/gift-app-google.5ca858a5.png";